export default class PromiseQueue {
    static queue = [];
    static pendingPromise = false;

    static enqueue(promiseFunction) {
        return new Promise((resolve, reject) => {
            this.queue.push({
                promiseFunction,
                resolve,
                reject,
            });
            this._dequeue();
        });
    }

    //You're not suppose to call that directly
    static _dequeue() {
        if (this.workingOnPromise) {
            return false;
        }
        const item = this.queue.shift();
        if (!item) {
            return false;
        }
        try {
            this.workingOnPromise = true;
            item.promiseFunction()
                .then((value) => {
                    this.workingOnPromise = false;
                    item.resolve(value);
                    this._dequeue();
                })
                .catch(err => {
                    this.workingOnPromise = false;
                    item.reject(err);
                    this._dequeue();
                })
        } catch (err) {
            this.workingOnPromise = false;
            item.reject(err);
            this._dequeue();
        }
        return true;
    }
}